import { MathUtils } from "three";
export var ColorConversion = /* @__PURE__ */ ((ColorConversion2) => {
  ColorConversion2["NONE"] = "no conversion";
  ColorConversion2["SRGB_TO_LINEAR"] = "sRGB -> linear";
  ColorConversion2["LINEAR_TO_SRGB"] = "linear -> sRGB";
  return ColorConversion2;
})(ColorConversion || {});
export const COLOR_CONVERSIONS = [
  "no conversion" /* NONE */,
  "sRGB -> linear" /* SRGB_TO_LINEAR */,
  "linear -> sRGB" /* LINEAR_TO_SRGB */
];
export class CoreColor {
  static set_hsv(h, s, v, target) {
    h = MathUtils.euclideanModulo(h, 1);
    s = MathUtils.clamp(s, 0, 1);
    v = MathUtils.clamp(v, 0, 1);
    target.setHSL(h, s * v / ((h = (2 - s) * v) < 1 ? h : 2 - h), h * 0.5);
  }
}
